import { render, staticRenderFns } from "./Badge1.vue?vue&type=template&id=1505eeee&scoped=true"
import script from "./Badge1.vue?vue&type=script&lang=js"
export * from "./Badge1.vue?vue&type=script&lang=js"
import style0 from "./Badge1.vue?vue&type=style&index=0&id=1505eeee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505eeee",
  null
  
)

export default component.exports